import { enableProdMode, NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { buildInfo } from 'environments/buildInfo';
import { renderEnvironment } from 'environments/render/environment';
import { RenderWebComponentModule } from 'render/render-webcomponent.module';


if (renderEnvironment.isProduction) {
  enableProdMode();
}

export function main(): Promise<void | NgModuleRef<RenderWebComponentModule>> {
  console.info(`[render-idt] version ${buildInfo.coreVersion}`);

  return platformBrowserDynamic()
    .bootstrapModule(RenderWebComponentModule)
    .catch((err: unknown) => console.error({ err, buildInfo }));
}

if (document.readyState === 'complete') {
  main();
} else {
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  document.addEventListener('DOMContentLoaded', main);
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  document.addEventListener('WCLoad', main);
}
